{
  "verse": {
    "loading": "Cargando versículo...",
    "error": "No se pudo cargar el versículo",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "arabicUnavailable": "(Árabe no disponible)",
    "english": "Inglés",
    "arabic": "العربية",
    "swapLanguage_aria": "Cambiar idioma",
    "toggleLanguage_title": "Alternar entre inglés y árabe",
    "reflect": "Reflexionar",
    "reflecting": "Pensando…",
    "reflect_aria": "Genera una reflexión personal que conecte este versículo con tu intención",
    "insights": "Perspectivas",
    "insights_aria": "Abrir Perspectivas del Quran con IA",
    "share": "Compartir",
    "share_aria": "Compartir este versículo como imagen",
    "share_title": "Compartir este versículo",
    "removeFromFavorites_aria": "Quitar de favoritos",
    "saveToFavorites_aria": "Guardar en favoritos",
    "favoritesProLocked_aria": "Favoritos es una función Pro",
    "favoritesUpgrade_aria": "Mejora para guardar favoritos",
    "signInToSave": "Inicia sesión para guardar favoritos.",
    "failedToUpdateFavorites": "No se pudieron actualizar los favoritos",
    "couldNotReflect": "No se pudo generar la reflexión",
    "shareCaption": "\"{{text}}\"\n— Surah {{surah}}, Ayah {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Imagen guardada · versículo copiado",
    "imageSaved": "Imagen del versículo guardada",
    "couldNotCreateImage": "No se pudo crear la imagen"
  },
  "insights": {
    "panel_aria": "Panel de Perspectivas del Quran",
    "title": "Perspectivas",
    "reference": "Surah {{surah}}, Ayah {{ayah}}",
    "close_aria": "Cerrar panel de Perspectivas",
    "versePreview_aria": "Vista previa del versículo",
    "back_aria": "Atrás",
    "tryAgain": "Reintentar",
    "backTo_aria": "Volver a {{ref}}",
    "copyVerse_aria": "Copiar {{ref}}",
    "openingVerse": "Abriendo el versículo…",
    "verseError": "No se pudo abrir el versículo."
  },
  "proGate": {
    "title": "Perspectivas del Quran con IA es una función Pro",
    "subtitleSafari": "Desbloquea una comprensión profunda y contextual de cada versículo con Rhemn Pro. ¿Ya eres miembro? Se desbloquea automáticamente al iniciar sesión.",
    "subtitle": "Desbloquea una comprensión profunda y contextual de cada versículo.",
    "bulletAsk": "Haz cualquier pregunta sobre el versículo",
    "bulletTafsir": "Resúmenes de Tafsir instantáneos con IA",
    "bulletRelated": "Descubre versículos relacionados temáticamente",
    "upgrade": "Mejorar a Pro"
  },
  "ask": {
    "heading": "Preguntar",
    "suggestion1": "¿Cuál es el contexto más amplio de este versículo?",
    "suggestion2": "¿Cómo puedo aplicar esto en la vida diaria?",
    "suggestion3": "¿Qué dicen los eruditos clásicos sobre esto?",
    "placeholder": "Pregunta lo que sea sobre este versículo…",
    "input_aria": "Haz una pregunta sobre este versículo",
    "submit_aria": "Enviar pregunta",
    "submit_title": "Enviar (⌘↵)",
    "submit_label": "Preguntar",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Preguntas sugeridas",
    "error": "No se pudo obtener una respuesta.",
    "pending": "Reflexionando sobre tu pregunta…",
    "attribution": "Respuesta generada con IA · No sustituye la erudición cualificada"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Obtén un resumen de Tafsir generado con IA para este versículo.",
    "generate": "Generar Tafsir",
    "commentary": "Comentario",
    "regenerate": "Regenerar",
    "regenerate_aria": "Regenerar Tafsir",
    "attribution": "Resumen generado con IA · No sustituye la erudición cualificada",
    "error": "No se pudo generar el tafsir.",
    "pending": "Leyendo el comentario…"
  },
  "related": {
    "heading": "Versículos relacionados",
    "copied": "Copiado: {{ref}}",
    "failedToCopy": "No se pudo copiar",
    "empty": "No se encontraron versículos relacionados.",
    "error": "No se pudieron cargar los versículos relacionados.",
    "pending": "Buscando versículos relacionados…"
  },
  "favorites": {
    "panel_aria": "Versículos favoritos",
    "title": "Versículos favoritos",
    "proLocked": "Los versículos favoritos son una función Pro.",
    "loading": "Cargando…",
    "failedToLoad": "No se pudieron cargar los favoritos",
    "empty": "Aún no hay favoritos. Toca el corazón en cualquier versículo para guardarlo.",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "remove_aria": "Quitar de favoritos",
    "failedToRemove": "No se pudo quitar"
  }
}
